import { useSearchParams } from "react-router-dom";

export function useChatId(): string | null {
  const [searchParams] = useSearchParams();
  return searchParams.get("chatId");
}
